<template>
  <div
    class="bg-[var(--fundoForm)] w-full p-2 rounded-md flex justify-center items-center text-[var(--text)]"
    
  >
    <form
      @submit.prevent="onSubmit"
      class="flex flex-col items-left gap-2 text-black outline-none focus:ring-2 focus:ring-[#2e2e48] p-2"
    >
      <h1 style="color: var(--titulo)">Configuração de Conexão com Base de Dados</h1>

      <!-- <FormInput
        v-model="empresa"
        id="empresa"
        label="Nome Empresa:"
        placeholder="Nome Empresa"
        readonly
      />
      <span v-if="errors.empresa" class="text-red-500">{{
        errors.empresa
      }}</span> -->

      <FormSelect
        v-model="selectedDatabase"
        id="database"
        label="DataBase:"
        :options="databases"
        placeholder="Seleciona BD"
        class="campo-form"
      />
      <span v-if="errors.selectedDatabase" class="text-red-500">{{
        errors.selectedDatabase
      }}</span>

      <FormInput v-model="host" id="host" label="Host:" placeholder="Host" class="campo-form"/>
      <span v-if="errors.host" class="text-red-500">{{ errors.host }}</span>

      <FormInput
        v-model="schemaName"
        id="schemaName"
        label="Nome da Empresa:"
        placeholder="Nome da Empresa"
        class="campo-form"
      />
      <span v-if="errors.schemaName" class="text-red-500">{{
        errors.schemaName
      }}</span>

      <FormInput
        v-model="redundancyServer"
        id="redundancyServer"
        label="Servidor Redundância:"
        placeholder="Servidor Redundância"
        class="campo-form"
      />
      <span v-if="errors.redundancyServer" class="text-red-500">{{
        errors.redundancyServer
      }}</span>

      <FormSelect
        v-model="selectedRedundancyType"
        id="redundancyType"
        label="Tipo Redundância:"
        :options="redundancyTypes"
        placeholder="Seleciona Tipo Redun..."
        class="campo-form"
      />
      <span v-if="errors.selectedRedundancyType" class="text-red-500">{{
        errors.selectedRedundancyType
      }}</span>

      <!-- Opções de Clonagem -->
      <fieldset>
        <legend style="color: var(--titulo);" >Opções de Clonagem:</legend>
        <label style="color: var(--label);">
          <input type="radio" v-model="copyDataOption" value="with_data" />
          Copiar Tabelas com Dados
        </label>
        <label style="color: var(--label);">
          <input type="radio" v-model="copyDataOption" value="without_data" />
          Copiar Tabelas sem Dados
        </label>
      </fieldset>
      <span v-if="errors.copyDataOption" class="text-red-500">{{
        errors.copyDataOption
      }}</span>

      <div class="text-right">
        <button
          v-if="validPermission('C0010')"
          type="submit"
          :disabled="isLoading"
          class="btn px-4 py-1 rounded-lg shadow-lg"
        >
          {{ isLoading ? "Salvando..." : "Clonar" }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import Cookies from "js-cookie";
import FormInput from "@/components/FormInput.vue";
import FormSelect from "@/components/FormSelect.vue";
import permissionMixin from "@/permissionMixin.js";
import axios from "axios";

export default {
  mixins: [permissionMixin],
  components: {
    FormInput,
    FormSelect,
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_URL_BASE,
      empresa: "",
      selectedDatabase: "",
      host: "",
      schemaName: "",
      redundancyServer: "",
      selectedRedundancyType: "",
      databases: [
        { id: 1, nome: "MySQL" },
        { id: 2, nome: "Postgres" },
        { id: 3, nome: "Oracle" },
      ],
      redundancyTypes: [
        { id: 1, nome: "Type 1" },
        { id: 2, nome: "Type 2" },
        { id: 3, nome: "Type 3" },
      ],
      copyDataOption: "with_data", // New data property
      isLoading: false,
      errors: {},
    };
  },
  methods: {
    validateForm() {
      this.errors = {};

      // ... existing validations

      if (!this.copyDataOption) {
        this.errors.copyDataOption = "Selecione uma opção de clonagem.";
      }

      return Object.keys(this.errors).length === 0;
    },
    async onSubmit() {
      if (!this.validateForm()) {
        toast.error("Por favor, preencha todos os campos obrigatórios.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        return;
      }

      this.isLoading = true;

      try {
        const response = await axios.post(
          `${this.baseURL}/api/v1/clonaSchema/`,
          {
            schema_name: this.schemaName,
            copy_data: this.copyDataOption === "with_data",
          }
        );

        if (response.status === 201) {
          toast.success("Schema criado com sucesso!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        } else {
          toast.error("Erro ao criar o schema.", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
        }
      } catch (error) {
        toast.error("Erro ao criar o schema.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        console.error("Erro ao criar o schema:", error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.button {
  background-color: var(--button);
  color: var(--iconCima);
  cursor: pointer;
}

.button[disabled] {
  cursor: not-allowed;
  opacity: 0.6;
}

.button:hover:not([disabled]) {
  filter: brightness(0.9);
}

.campo-form :deep(label) {
  color: var(--label);
  font-weight: 600;
}

.campo-form :deep(input),
.campo-form :deep(select) {
  color: var(--text); /* cor do texto digitado */
  /* background-color: var(--label);  */
  border-color: var(--label);
}

.campo-form :deep(input::placeholder) {
  color: var(--placeholder-color); /* cor do placeholder */
}

.text-white {
  color: var(--label); /* cor do texto branco */
}
</style>
